export default {
    Overview: "Tổng quan",
    Argument: "Tham số",
    Period: "Kỳ báo cáo",
    Report: "Báo cáo",
    ViewFollow: "Xem theo",
    Title: "Tiêu đề",
    Subtitle: "Tiêu đề con",
    OrganizationUnit: "Cơ cấu tổ chức",

    AmountCourseStudent:{
        
        
    },
    TrainingResult:{

    },
    TrainingContentAnalysis:{

    },
    CourseQuality:{

    }
    
}